// Mirrors the API's ASP.NET Identity password options (Web.Api Startup): every rule must hold,
// and the letter/digit checks are ASCII, so any other character counts as the special character.
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_RULE_LABELS = {
    minLength: 'At least {{count}} characters',
    uppercase: 'One uppercase letter (A–Z)',
    lowercase: 'One lowercase letter (a–z)',
    digit: 'One number (0–9)',
    special: 'One special character, such as ! @ # $',
} as const;

export const PASSWORD_POLICY_MESSAGE =
    'Password must be at least {{count}} characters and include an uppercase letter, a lowercase letter, a number and a special character.';
